import { create } from "zustand";
import { initialState, TCacheStore } from "./cache.state";
import { createCacheActions } from "./cache.actions";

/**
 * State management store of the V3 search - Cache (disclosures) metadata
 * @example
 * ```
 * const graphicsDisclosures = useCacheStore((state) => state.graphicsDisclosures)
 * const dispatch = useCacheStore((state) => state.dispatch)
 * dispatch({ type: SearchActions.SET_CACHE_TOPICS, payload: { type: "images", disclosures: [...] } })
 * ```
 */
export const useCacheStore = create<TCacheStore>((set) => ({
    ...initialState,
    ...createCacheActions(set),
}));
